var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.operateMaps[_vm.operate] || "-",
          backUrl: "/marketing/pop-qrcode/qrcodeList",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formValidate",
              staticClass: "formValidate form-boder-padding",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "108px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    _vm._b({}, "el-col", _vm.grid, false),
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客服名称：", prop: "pageName" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              maxlength: "100",
                              "show-word-limit": "",
                              placeholder: "请输入客服名称",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.pageName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "pageName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.pageName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "客服简介：", prop: "popupIntro" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              maxlength: "100",
                              "show-word-limit": "",
                              placeholder: "请输入客服简介",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.popupIntro,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "popupIntro",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.popupIntro",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "客服头像：", prop: "popupAvatar" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox acea-row",
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTap("popupAvatar")
                                },
                              },
                            },
                            [
                              _vm.formValidate.popupAvatar
                                ? _c("div", { staticClass: "pictrue" }, [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.formValidate.popupAvatar,
                                      },
                                    }),
                                  ])
                                : _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                                  ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isDisabled,
                                  expression: "!isDisabled",
                                },
                              ],
                              staticClass: "from-tips",
                            },
                            [_vm._v("建议尺寸：280*280px，上传小于1mb的图片")]
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "客服二维码：", prop: "qrcodeImage" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox acea-row",
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTap("qrcodeImage")
                                },
                              },
                            },
                            [
                              _vm.formValidate.qrcodeImage
                                ? _c("div", { staticClass: "pictrue" }, [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.formValidate.qrcodeImage,
                                      },
                                    }),
                                  ])
                                : _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                                  ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isDisabled,
                                  expression: "!isDisabled",
                                },
                              ],
                              staticClass: "from-tips",
                            },
                            [_vm._v("建议尺寸：280*280px，上传小于1mb的图片")]
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "跳转链接：", prop: "jumpUrl" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              placeholder: "请输入跳转链接",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formValidate.jumpUrl,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formValidate,
                                  "jumpUrl",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formValidate.jumpUrl",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否开启：", prop: "isEnabled" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": "是",
                              "inactive-text": "否",
                            },
                            model: {
                              value: _vm.formValidate.isEnabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "isEnabled", $$v)
                              },
                              expression: "formValidate.isEnabled",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _vm.checkPermi([
                    "platform:marketing:popQrcode:qrcode:save",
                    "platform:marketing:popQrcode:qrcode:update",
                  ])
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isDisabled,
                              expression: "!isDisabled",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary", loading: _vm.loadingBtn },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmit("formValidate")
                            },
                          },
                        },
                        [_vm._v("保存")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }